<button
    #menu="cdkOverlayOrigin"
    cdkOverlayOrigin
    interacta-icon-button
    type="button"
    [icon]="'ellipsis-vertical'"
    [label]="tooltip()"
    (click)="menuIsOpen.set(true)"
></button>
<interacta-menu
    [open]="menuIsOpen()"
    [origin]="menu"
    (closing)="menuIsOpen.set(false)"
>
    @for (item of itemsFiltered(); track $index) {
        @if (item.type === 'link') {
            <a
                interactaMenuItemDecorator
                type="button"
                [queryParams]="
                    { row: args(), params: item.queryParams }
                        | apply: queryParams
                "
                [routerLink]="{ args: args(), link: item.link } | apply: link"
                [target]="item.target"
            >
                <ng-container
                    *ngTemplateOutlet="
                        itemTemplate;
                        context: { $implicit: item }
                    "
                />
            </a>
        } @else {
            <button
                interactaMenuItemDecorator
                type="button"
                (click)="item.click(args())"
            >
                <ng-container
                    *ngTemplateOutlet="
                        itemTemplate;
                        context: { $implicit: item }
                    "
                />
            </button>
        }
        @if ({ args: args(), separator: item.separator } | apply: separator) {
            <interacta-separator class="px-16 py-4" [thickness]="'soft'" />
        }
    }
</interacta-menu>

<ng-template #itemTemplate let-item>
    <interacta-icon
        class="size-24"
        [icon]="{ icon: item.icon, row: args() } | apply: icon"
    />
    <span class="typo-sm">{{
        { label: item.label, row: args() } | apply: label | translate
    }}</span>
</ng-template>
